<loader *ngIf="saving"></loader>

<cat-docs
  [selectMode]="true"
  [createDocType]="'LC'"
  [viewDocNavUrl]="'main/lc/cat-doc'"
  [navMode]="navMode"
  (onDocsSelected)="onDocsSelected($event)"
></cat-docs>
